import axios from './axios'

const isIntercept = async (channel) => {
  return new Promise(async (resolve, reject) => {
    if (!channel) { 
      resolve(true) 
      return
    }
    
    const { data } = await axios.post('/index/v1/channelRegisStatus', {
      channel
    })
    if (data && data.success) {
      const _jump = data.data?.channelRegisStatus === 'N'
      if (_jump) {  
        window.location.replace('/landing/intercept')
      } else {
        resolve(_jump)
      }
    } else {
      resolve(true)
    }
  })
}

export default isIntercept